(function() {
    'use strict';

    var ListTagCtrl = function($scope, $uibModalInstance, ajaxCall, $sce) {

        console.log("Inside ListTagCtrl");

        $scope.listTabModel = {};
        $scope.listTabModel.errorMessage     = false;
        $scope.listTabModel.showLoader       = false;
        $scope.listTabModel.disableAddBtn    = false;
        $scope.listTabModel.disableRemoveBtn = false;

        $scope.pageLoaded = false;

        $scope.onloadPop = function() {
            if ($scope.pageLoaded != true) {
                $scope.listTabModel.showLoader = true;
                $scope.listTabModel.errorMessageNoSelection = false;
                $scope.pageLoaded = true;

                var idList            = $scope.listTabModel.idList;
                var listTagObjectType = $scope.listTabModel.listTagObjectType;
                var mode              = $scope.listTabModel.mode;
                var linkedObjectType  = $scope.listTabModel.linkedObjectType;

                if($scope.listTabModel.allListPage == 'true'){
                    var sic     = $scope.listTabModel.searchInputCookie;
                    var data    = 'sic=' + parseInt(sic) + '&objectType=' + listTagObjectType + '&mode=' + mode;
                    var ajaxUrl = WEBAPP_PATH + "/listTag/listTagAllSaveAjax";

                    ajaxCallList(ajaxUrl , data);
                } else if (idList != null && idList.length != 0) {
                    var data    = 'idList=' + idList + '&objectType=' + listTagObjectType + '&mode=' + mode + '&linkedObjectType=' + linkedObjectType;
                    var ajaxUrl = WEBAPP_PATH + "/listTag/listTagSelectedSaveAjax";

                    ajaxCallList(ajaxUrl , data);
                } else {
                    $scope.listTabModel.errorMessage = true;
                }
            }
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.reloadObjectTags = function(){
            var listTabModel = $scope.listTabModel;
            var data    = 'idList=' +listTabModel.idList + '&objectType=' + listTabModel.listTagObjectType + '&mode=' + listTabModel.mode + '&linkedObjectType=' + listTabModel.linkedObjectType;
            var ajaxUrl = WEBAPP_PATH + "/listTag/listTagSelectedSaveAjax";
            $scope.divTags = "";
            $scope.listTabModel.showLoader       = true;
            ajaxCallList(ajaxUrl , data);
        }

        var ajaxCallList = function(ajaxUrl, data) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.listTabModel.showLoader       = false;
                    $scope.listTabModel.disableAddBtn    = false;
                    $scope.listTabModel.disableRemoveBtn = false;
                    $scope.divTags                       = $sce.trustAsHtml(result.data);
                },
                function(result) {
                    $scope.listTabModel.showLoader       = false;
                    $scope.listTabModel.disableAddBtn    = false;
                    $scope.listTabModel.disableRemoveBtn = false;
                    $scope.divTags                       = $sce.trustAsHtml(errorMsg);
                }
            );
        }

        $scope.fnAddExistingListTagNg = function($event) {
            $event.preventDefault();

            $scope.listTabModel.showLoader    = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag       = $scope.listTabModel.existingTag;
            var processing        = $scope.listTabModel.processing;
            var idList            = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;

            if (processing == '0' && existingTag) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType;
                data = data + '&existingTag=' + encodeURIComponent(existingTag);
                var ajaxUrl = WEBAPP_PATH + "/listTag/appendListTag";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnAddListTagNg = function($event) {
            $event.preventDefault();

            $scope.listTabModel.showLoader    = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag       = $scope.listTabModel.existingTag;
            var processing        = $scope.listTabModel.processing;
            var listName          = $scope.listTabModel.listName;
            var idList            = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;

            if (processing == '0' && listName.trim().length > 0) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType;
                data = data + '&tagName=' + encodeURIComponent(listName.trim());

                var ajaxUrl = WEBAPP_PATH + "/listTag/addListTagCheck";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnAppendListTagNg = function($event) {
            $event.preventDefault();

            $scope.listTabModel.showLoader    = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag       = $scope.listTabModel.tagSelected;
            var processing        = $scope.listTabModel.processing;
            var idList            = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;
            if (processing == '0' && existingTag) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType;
                data = data + '&existingTag=' + encodeURIComponent(existingTag);
                var ajaxUrl = WEBAPP_PATH + "/listTag/appendListTag";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnOverwriteListTagNg = function($event) {
            $event.preventDefault();
            $scope.listTabModel.showLoader = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag = $scope.listTabModel.tagSelected;
            var processing = $scope.listTabModel.processing;
            var idList = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;
            if (processing == '0' && existingTag) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType;
                data = data + '&existingTag=' + encodeURIComponent(existingTag);

                var ajaxUrl = WEBAPP_PATH + "/listTag/overwriteListTag";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnOverwriteListTagNg = function($event) {
            $event.preventDefault();
            $scope.listTabModel.showLoader = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag = $scope.listTabModel.tagSelected;
            var processing = $scope.listTabModel.processing;
            var idList = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;
            if (processing == '0' && existingTag) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType;
                data = data + '&existingTag=' + encodeURIComponent(existingTag);

                var ajaxUrl = WEBAPP_PATH + "/listTag/overwriteListTag";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnRemoveFromListNg = function($event) {
            $event.preventDefault();
            var matchingList = $scope.listTabModel.matchingList;
            var processing = $scope.listTabModel.processing;
            var idList = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            if (processing == '0' && matchingList) {
                $scope.listTabModel.errorMessageNoSelection = false;
                $scope.listTabModel.disableRemoveBtn = true;
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType;
                data = data + '&tagName=' + encodeURIComponent(matchingList);
                var ajaxUrl = WEBAPP_PATH + "/listTag/removeFromListTag";
                $scope.listTabModel.showLoader = true;
                ajaxCallList(ajaxUrl , data);
            } else {
                $scope.listTabModel.errorMessageNoSelection = true;
            }
            return false;
        }

        $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }

    }
    ListTagCtrl.$inject = ['$scope', '$uibModalInstance', 'ajaxCall', '$sce'];
    angular.module('app').controller('ListTagCtrl', ListTagCtrl);

}());